import toast from "react-hot-toast";
import BaseListPresenter from "../../../../../base/BaseListPresenter";

class PendingListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    deleteObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      upsertUseCase,
      deleteObjectUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  init() {
    this.limit = 20;
    this.where = {
      registrationStatus: "Pending",
      is_Delete: { $exists: false },
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  onClickView(index) {
    const { id } = this.objects[index];

    this.view.navigateTo(id);
  }

  onChange(value) {
    this.view.setStartDate(value);
  }

  async onClickApprove(index) {
    try {
      const currentUser = this.view.getCurrentUser();
      const collectionName = this.view.getCollectionName();
      const object = this.objects[index];
      await this.view.showAdditionalInformationModal(
        object,
        this.onChange.bind(this),
      );

      const role = await this.findObjectUseCase.execute("roles", {
        where: { name: "affiliate" },
      });

      const newObject = {
        ...object,
        startDate: this.view.state.startDate,
        roles: [{ id: "affiliate" }],
        approvedBy: { id: currentUser.id },
        registrationStatus: "Approved",
      };

      delete newObject.roles[0]?.acl;

      console.log("new", newObject);

      await this.upsertUseCase.execute(collectionName, newObject);
      toast.success("User approved successfully", { position: "top-right" });
      this.getObjects();
    } catch (error) {}
  }
}

export default PendingListPresenter;
